'use client'

import { HorizontalAd } from '@/components/ui/ad-placement'

export function BlogAdSection() {
  return <HorizontalAd slot="8879381652" lazy className="my-8" />
}
